import {createRoot} from 'react-dom/client'
// Axios
import {StrictMode} from 'react'
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AxiosProvider} from './app/AxiosProvider'
import {Private} from './app/modules/apps/chat/components/Private'
import ChatSupportWidget from './app/modules/apps/chat/components/ChatSupportWidget'
import {ClerkProvider} from '@clerk/react'

Chart.register(...registerables)

const queryClient = new QueryClient()
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || ''
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    // <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <AxiosProvider>
        <QueryClientProvider client={queryClient}>
          <MetronicI18nProvider>
            {/* <AuthProvider> */}
            <AppRoutes />
            {/* <ChatSupportWidget /> */}
          </MetronicI18nProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </AxiosProvider>
    </ClerkProvider>
    // </StrictMode>
  )
}
